<template>
  <div class="container py-6">

    <div>
      <header class="title is-5">
        Production Status
      </header>

      <table class="table is-hoverable is-fullwidth sticky-header">
        <thead>
          <tr>
            <th 
              v-for="(header, headerIndex) in headers"
              :key="headerIndex">
              {{ header }}
            </th>
          </tr>
        </thead>

        <tbody>
          <template 
            v-for="taskGroup in masterProductions">
            <tr 
              v-if="taskGroup.production_steps.length > 0"
              class="has-background-light subheader"
              :key="taskGroup.id">
              <td :colspan="headers.length">
                <router-link :to="taskNavigation(taskGroup)">
                  {{ taskGroup.project.project_name }} ({{ taskSource(taskGroup) }})
                </router-link>
              </td>
            </tr>
            <tr 
              v-for="task in taskGroup.production_steps" 
              :key="task.id"> 
              <td>
                {{ task.step.work_name }}
              </td>
              <td>
                {{ task.finished_qty }}
              </td>
              <td>
                {{ task.qty_assigned }}
              </td>
              <td>
                {{ task.total_linear_ft }}
              </td>
              <td>
                {{ task.linear_ft_assigned }}
              </td>
              <td>
                {{ task.linear_ft_in_progress }}
              </td>
              <td>
                {{ task.linear_ft_completed }}
              </td>
              <td>
                {{ format(parse(task.started_on)) }}
              </td>
              <td>
                {{ format(parse(task.completed_on)) }}
              </td>
              <td>
                {{ task.exp_duration_min_str }}
              </td>
              <td>
                {{ task.duration_min_str }}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <v-pagination 
      v-if="pagination.pages > 1"
      :value="pagination.page"
      @input="changePage"
      :length="pagination.pages"/>

  </div>
</template>

<script>
import VPagination from '@/components/base/VPagination'
import { mapState, mapActions, mapMutations } from 'vuex'

import { parseISO, format } from 'date-fns'

export default {
  components: { VPagination },
  data() {
    return {
      headers: [
        'Task', 'Quantity Need', 'Quantity Assigned', 'Total Linear Ft.',
        'Linear Ft. Assigned', 'Linear Ft. in Progress', 'Linear Ft. Completed',
        'Started On', 'Completed On',
        'Expected Duration', 'Actual Duration'
      ],
      parse: (d) => {
        return d ? parseISO(d) : null
      },
      format: (d) => {
        return d ? format(d, 'yyyy-MM-dd H:mm:ss') : null
      }
    }
  },
  computed: {
    ...mapState("masterProductions", [
      "masterProductions", "pagination"
    ])
  },
  watch: {
    'pagination.page'(page) {
      this.getMasterProductions({ page: page });
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("masterProductions", ["getMasterProductions"]),
    ...mapMutations("masterProductions", ["changePage"]),
    initialize() {
      this.getMasterProductions();
    },
    taskSource(taskGroup) {
      if (taskGroup.part_type == 'production_sheet_item_id') {
        return 'Production Sheet'
      } else if (taskGroup.part_type == 'cutsheetpart_id') {
        return 'Cut Sheet'
      } else if (taskGroup.part_type == 'assemblysheet_id') {
        return 'Assembly Sheet'
      }
    },
    taskNavigation(taskGroup) {
      if (taskGroup.part_type == 'production_sheet_item_id') {
        return {
          name: 'ProductionSheetViewer',
          params: {
            productionSheetId: taskGroup.production_sheet_item.production_sheet.id
          }
        }
      } else if (taskGroup.part_type == 'cutsheetpart_id') {
        return {
          name: 'CutSheetViewer',
          params: {
            cutSheetId: taskGroup.cutsheet_part.cutsheet.id
          }
        }
      } else if (taskGroup.part_type == 'assemblysheet_id') {
        return {
          name: 'AssemblyView',
          params: {
            assemblySheetId: taskGroup.assembly_sheet_id
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';
</style>